export const TEXTS = {
  OFERTA_TITLE: 'При регистрации вы соглашаетесь с ',
  OFERTA_LINK: 'условиями публичной оферты',
  COOKIE_POLICY_TITLE: ' и подтверждаете, что ознакомились с ',
  COOKIE_POLICY_LINK: 'Политикой в отношении обработки файлов cookie',
};
